export  const stopTrackCrossOrigin = () => {
  const allWarningButtons = document.querySelectorAll('.warning-button, .no-class-link');

  allWarningButtons.forEach(button => {
    if (button.href) {
      const originalUrl = button.href;

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.open(originalUrl, '_blank');
      }, true);
    }
  });
}

stopTrackCrossOrigin();
